import { subMonths, subWeeks } from 'date-fns';

import { DateFilterValue } from '@components';

export const getDefaultFromToDates = (numberOfWeeks = 6) => {
  const from = !numberOfWeeks ? new Date() : subWeeks(new Date(), numberOfWeeks);
  from.setHours(0, 0, 0);

  const to = new Date();
  to.setHours(23, 59, 59);

  return {
    from,
    to,
  };
};

export const validateDateFilterMaxMonths = (dateFilter: DateFilterValue, maxMonths?: number) => {
  if (!dateFilter.from || !dateFilter.to) {
    return true;
  }

  const minAllowedTimestamp = Math.floor(+subMonths(+dateFilter.to, maxMonths || 3) / 1000);
  const selectedFromTimestamp = Math.floor(+dateFilter.from / 1000);

  return selectedFromTimestamp > minAllowedTimestamp;
};

export const validateDateFilterMaxYears = (dateFilter: DateFilterValue, maxYears: number = 2) => {
  return validateDateFilterMaxMonths(dateFilter, maxYears * 12);
};
